module.exports = __webpack_public_path__ + "img/blue-and-yellow.e0d79d77.png";